import { render, staticRenderFns } from "./AdsManagerFilter.vue?vue&type=template&id=845546f8&scoped=true&"
import script from "./AdsManagerFilter.vue?vue&type=script&lang=ts&"
export * from "./AdsManagerFilter.vue?vue&type=script&lang=ts&"
import style0 from "./AdsManagerFilter.vue?vue&type=style&index=0&id=845546f8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "845546f8",
  null
  
)

export default component.exports